import { Component, EventEmitter, Input, Output } from '@angular/core';
import { DialogService } from 'primeng/dynamicdialog';
import { TranslateService } from '@ngx-translate/core';
import { AssessmentMemberAnswer } from '../../../../../models/assessment-member-answer';
import { MemberAnswerOption } from '../../models/member-answer-option.enum';

@Component({
  selector: 'lib-survey-boolean-question',
  templateUrl: './survey-boolean-question.component.html',
  styleUrls: ['./survey-boolean-question.component.scss']
})
export class SurveyBooleanQuestionComponent {
  @Input() templateMemberAnswer: AssessmentMemberAnswer = new AssessmentMemberAnswer();
  @Input() index = 0;
  @Input() userAssessmentMemberAnswer: AssessmentMemberAnswer;
  @Output() openMemberAnswersModalEvent: EventEmitter<null> = new EventEmitter<null>();
  @Output() openCustomFieldsModalEvent: EventEmitter<null> = new EventEmitter<null>();
  public booleanSelectOptions = [
    {
      label: this.translateService.instant('common.yes'),
      value: MemberAnswerOption.yes
    },
    {
      label: this.translateService.instant('common.no'),
      value: MemberAnswerOption.no
    },
    {
      label: this.translateService.instant('common.na'),
      value: MemberAnswerOption.na
    }
  ];

  constructor(private dialogService: DialogService,
              private translateService: TranslateService) {
  }

  openMemberAnswersModal() {
    this.openMemberAnswersModalEvent.emit();
  }

  commentsIsRequired(): boolean {
    return this.userAssessmentMemberAnswer?.questionAnswer?.toUpperCase() === this.translateService.instant('common.na').toUpperCase();
  }

  setNull(userAssessmentMemberAnswer: AssessmentMemberAnswer): void {
    if (!userAssessmentMemberAnswer?.questionAnswer?.length) {
      userAssessmentMemberAnswer.questionAnswer = null;
    }
  }
}
